import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';
import { PeriodicityTypes } from '../../../src/types/Periodicity';

export { PeriodicityTypes };

export interface Params {
  product_id: number;
  periodicity: PeriodicityTypes;
}

export function postSetPeriodicity(params: Params) {
  return send<unknown>({
    path: '/api/set_periodicity/',
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
    body: {
      product_id: params.product_id,
      periodicity: params.periodicity,
    },
  });
}
